import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { getFeaturedContents } from './models';

import { FeaturedContentCarousel as FeaturedContentCarouselFeature } from '@/features/NewLanding';
import { Skeleton } from '@/shared/Components';

const FeaturedContentCarousel = () => {
  const slidesPromise = getFeaturedContents();

  return (
    <ErrorBoundary
      fallback={<Skeleton className="h-[320px] w-full desktop:h-[376px]" />}
    >
      <Suspense
        fallback={<Skeleton className="h-[320px] w-full desktop:h-[376px]" />}
      >
        <FeaturedContentCarouselFeature slidesPromise={slidesPromise} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default FeaturedContentCarousel;
